import React, { useState, useEffect, useRef } from 'react';
import styles from '../static/styles/GameRatingPopup.module.css';

const LABELS = ['', 'Terrible', 'Bad', 'Okay', 'Good', 'Amazing'];

const GameRatingPopup = ({ isOpen, message, onClose, onSubmit }) => {
    const [rating, setRating] = useState(0);
    const [hover, setHover] = useState(0);
    const [feedback, setFeedback] = useState('');
    const textAreaRef = useRef(null);

    useEffect(() => {
        if (!isOpen) return;

        const canvases = Array.from(document.querySelectorAll('canvas'));
        const prevHandlers = canvases.map(c => c.onfocus);

        // Whenever Unity tries to re-grab canvas focus, immediately give it back to the textarea
        canvases.forEach(c => {
            c.blur();
            c.onfocus = () => {
                c.blur();
                textAreaRef.current?.focus();
            };
        });

        setTimeout(() => textAreaRef.current?.focus(), 100);

        return () => {
            canvases.forEach((c, i) => {
                c.onfocus = prevHandlers[i];
            });
        };
    }, [isOpen]);

    if (!isOpen) return null;

    const active = hover || rating;

    const handleSubmit = () => {
        if (rating === 0) return;
        if (onSubmit) onSubmit({ rating, feedback });
        setRating(0);
        setFeedback('');
        onClose();
    };

    const handleSkip = () => {
        setRating(0);
        setFeedback('');
        onClose();
    };

    return (
        <div className={styles.overlay} onClick={handleSkip}>
            <div className={styles.card} onClick={(e) => e.stopPropagation()}>
                <div className={styles.topBar} />

                <p className={styles.message}>{message}</p>

                <div className={styles.starsRow}>
                    {[1, 2, 3, 4, 5].map((star) => (
                        <button
                            key={star}
                            className={`${styles.star} ${star <= active ? styles.starActive : ''}`}
                            onClick={() => setRating(star)}
                            onMouseEnter={() => setHover(star)}
                            onMouseLeave={() => setHover(0)}
                        >
                            ★
                        </button>
                    ))}
                </div>

                <span className={styles.ratingLabel}>
                    {active ? LABELS[active] : 'Tap a star to rate'}
                </span>

                <textarea
                    ref={textAreaRef}
                    className={styles.textarea}
                    placeholder="Leave a comment (optional)"
                    value={feedback}
                    onChange={(e) => setFeedback(e.target.value)}
                    rows={3}
                />

                <button
                    className={`${styles.submitBtn} ${rating === 0 ? styles.submitDisabled : ''}`}
                    onClick={handleSubmit}
                    disabled={rating === 0}
                >
                    Submit Rating
                </button>

                <button className={styles.skipBtn} onClick={handleSkip}>
                    Skip
                </button>
            </div>
        </div>
    );
};

export default GameRatingPopup;
